<template>
	<v-container class="maxw-40">
		<v-card class="pa-5">
			<v-form>
				<v-text-field
					label="Current password"
					:type="passwordInputType"
					v-model="formValue.currentPassword"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>

				<v-text-field
					label="New password"
					:type="passwordInputType"
					v-model="formValue.newPassword"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>

				<v-text-field
					label="Confirm new password"
					:type="passwordInputType"
					v-model="passwordConfirmation"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>

				<div class="d-flex justify-space-between align-end">
					<div class="text-center text-muted">
						<router-link :to="{ name: 'auth-profile' }">Back to profile</router-link>
					</div>
					<v-btn rounded type="submit" @click.prevent="submit" color="primary">Change Password</v-btn>
				</div>
			</v-form>
		</v-card>

		<transition name="fade">
			<app-feedback v-if="errorMessage" class="mt-5" @closed="errorMessage = ''">{{ errorMessage }}</app-feedback>
		</transition>
	</v-container>
</template>

<script>
import appFeedback from '@/components/common/Feedback.vue';
import soilApiService from '../../services/soilApiService';

const initialFormValue = {
	currentPassword: '',
	newPassword: '',
};

export default {
	components: {
		appFeedback,
	},
	data() {
		return {
			errorMessage: '',
			passwordConfirmation: '',
			showPasswords: false,
			formValue: { ...initialFormValue },
		};
	},
	computed: {
		passwordInputType() {
			return this.showPasswords ? 'text' : 'password';
		},
		passwordShowHideText() {
			return this.showPasswords ? 'Hide passwords' : 'Show passwords';
		},
	},
	methods: {
		async submit() {
			this.errorMessage = '';

			if (this.formValue.newPassword.trim() === '') {
				this.errorMessage = 'You must enter a password.';
				return;
			}

			if (this.formValue.newPassword !== this.passwordConfirmation) {
				this.errorMessage = 'New passwords do not match.';
				return;
			}

			try {
				await soilApiService.updatePassword({
					currentPassword: this.formValue.currentPassword,
					newPassword: this.formValue.newPassword,
				});

				this.$router.push('/');
			} catch (error) {
				this.errorMessage = 'An error has occurred. Please try again.';
			}
		},
	},
};
</script>

<style scoped>
a {
	text-decoration: none;
}
</style>
